import * as Yup from "yup";

const ValidationForgotPassword = Yup.object().shape({
    email: Yup.string().email("You must enter a valid email address").min(2, "Too Short").required("Required"),
});

export default ValidationForgotPassword;
